/* eslint-disable global-require */
const devModules: RouteConfig[] = [
  require('@/modules/FPKG-10000-Theme/router').default,
  require('@/modules/FPKG-30000-Permission/router').default,
  require('@/modules/FPKG-40000-Account/router').default,
  require('@/modules/FPKG-60000-Organization/router').default,
  require('@/modules/FPKG-70000-Transaction/router').default,
  require('@/modules/FPKG-90000-FedCustom/router').default,

];

/** 用陣列手法總和模組，以避免遺漏的情況 */
export default devModules.reduce((acc, cur: any) => acc.concat(cur), []);
